export default [
  {
    name: "APP_LOGIN_SUCCESS",
    callback: function(e) {
      console.log(e);
      this.$router.push({ path: "dashboard" });
    }
  },
  {
    name: "APP_LOGOUT",
    callback: function(e) {
      console.log(e);
      localStorage.clear();
      this.snackbar = {
        show: true,
        color: "green",
        text: "Logout successfully."
      };
      this.$router.replace({ path: "/company/login" });
    }
  },
  {
    name: "APP_PROFILE",
    callback: function(e) {
      console.log(e);
      this.$router.replace({ path: "/company/profile" });
    }
  },
  {
    name: "APP_COMPANY",
    callback: function(e) {
      console.log(e);
      this.$router.replace({ path: "/company/company-profile" });
    }
  },
  {
    name: "APP_SIGN_IN",
    callback: function() {
      this.$router.replace({ path: "/signin" });
    }
  },
  {
    name: "APP_SIGN_EMERGENCY",
    callback: function() {
      this.$router.replace({ path: "/emergency" });
    }
  },
  {
    name: "APP_SIGN_OUT",
    callback: function() {
      this.$router.replace({ path: "/signout" });
    }
  },
  {
    name: "APP_PAGE_LOADED",
    callback: function(e) {
      console.log(e);
    }
  },
  {
    name: "APP_AUTH_FAILED",
    callback: function(e) {
      console.log(e);
      this.$router.push("/login");
      this.$message.error("Token has expired");
    }
  },
  {
    name: "APP_BAD_REQUEST",
    // @error api response data
    callback: function(msg) {
      this.$message.error(msg);
    }
  },
  {
    name: "APP_ACCESS_DENIED",
    // @error api response data
    callback: function(msg) {
      this.$message.error(msg);
      this.$router.push("/forbidden");
    }
  },
  {
    name: "APP_RESOURCE_DELETED",
    // @error api response data
    callback: function(msg) {
      this.$message.success(msg);
    }
  },
  {
    name: "APP_RESOURCE_UPDATED",
    // @error api response data
    callback: function(msg) {
      this.$message.success(msg);
    }
  }
];
